import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import ui from './modules/ui';
import act from './modules/act';
import camps from './modules/camps';
import documents from './modules/documents';
import transport from './modules/transport';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production' || process.env.MODE_VUE_DEVTOOLS === 'enabled';
// Fix: No Vuex store detected https://github.com/vuejs/vue-devtools/issues/405
Vue.config.devtools = debug;

const store = new Vuex.Store({
  state: {
    error: null
  },
  mutations: {
    ERROR_OCCURRED(state, error) {
      state.error = error;
    }
  },
  modules: {
    auth,
    ui,
    act,
    camps,
    documents,
    transport
  },
  strict: debug
});

export { store as default };
